import * as actions from "../constants/actionTypes";
import * as utils from "../utils/utils";

const initialState = {
    commodityGroups: [],
    current: null,
    loading: false,
    saving: false
};

export default function commodityGroups(state = initialState, action) {
    let newState = Object.assign({}, state);

    switch (action.type) {
        case actions.LOADING_COMMODITY_GROUP:
            newState.loading = true;
            break;

        case actions.SAVING_COMMODITY_GROUP:
            newState.saving = true;
            break

        case actions.RECEIVED_COMMODITY_GROUPS:
            newState.loading = false;
            newState.commodityGroups = utils.mapById(action.payload)
            break

        case actions.RECEIVED_COMMODITY_GROUP:
            newState.loading = false;
            newState.current = action.payload
            break

        case actions.SAVED_COMMODITY_GROUP:
            let found = false;

            for (let i = 0; i < newState.commodityGroups.length; i++) {
                if(newState.commodityGroups[i].id === action.payload.id){
                    found = true;

                    newState.commodityGroups[i] = action.payload;
                }
            }

            if(!found) {
                newState.commodityGroups.add(
                    action.payload
                );
            }

            newState.loading = false;
            newState.saving = false;
            break;

        case actions.ERROR_SAVING_COMMODITY_GROUP:
            newState.loading = false;
            newState.saving = false;
            break;

        default: break;
    }
    return newState;
}



// WEBPACK FOOTER //
// ./src/reducers/commodityGroup.js